<template>
  <container-wrapper :designer="designer" :widget="widget" :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList">
    <div class="custom-sub-form-container flex" :class="{ selected: selected }" @click.stop="selectWidget(widget)">
      <div
        v-if="!widget.options.labelHidden"
        :style="{ width: widget.options.labelWidth || 80 + 'px' }"
        :class="[widget.options.labelAlign, !!widget.options.labelWrap ? 'label-wrap' : '', widget.options.size, 'label']"
      >
        {{ widget.options.label }}
      </div>
      <el-form label-position="top" style="flex: 1">
        <draggable
          :list="widget.widgetList"
          v-bind="{ group: 'dragGroup', ghostClass: 'ghost', animation: 200 }"
          handle=".drag-handler"
          :move="checkContainerMove"
          @add="onSubFormDragAdd($event, widget.widgetList)"
          @end="onSubFormDragEnd"
          @update="onContainerDragUpdate"
        >
          <transition-group name="fade" tag="div" class="sub-form-table">
            <template v-for="(subWidget, swIdx) in widget.widgetList">
              <div :key="subWidget.id + 'tc'" class="sub-form-table-column" :style="{ width: subWidget.options.columnWidth }">
                <component
                  :is="subWidget.type + '-widget'"
                  :key="subWidget.id"
                  :field="subWidget"
                  :designer="designer"
                  :parent-list="widget.widgetList"
                  :index-of-parent-list="swIdx"
                  :parent-widget="widget"
                  :design-state="true"
                  :sub-form-item-flag="true"
                ></component>
              </div>
            </template>
          </transition-group>
        </draggable>
      </el-form>
    </div>
  </container-wrapper>
</template>

<script>
import { VFormSDK } from "@/CommonDP/lib/vform/VFormDesigner.umd.min.js";
const { Draggable, i18n, ContainerWrapper, containerMixin, FieldComponents, refMixinDesign } = VFormSDK;

export default {
  name: "CustomSubFormWidget",
  componentName: "ContainerWidget",
  mixins: [i18n, containerMixin, refMixinDesign],
  inject: ["refList"],
  components: {
    ContainerWrapper,
    Draggable,
    ...FieldComponents
  },
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object
  },
  provide() {
    return {
      getSubFormFieldFlag: () => true,
      getSubFormName: () => this.widget.options.name
    };
  },
  computed: {
    selected() {
      return this.widget.id === this.designer.selectedId;
    },

    customClass() {
      return this.widget.options.customClass || "";
    }
  },
  watch: {
    //
  },
  created() {
    this.initRefList();
  },
  mounted() {
    //
  },
  methods: {
    onSubFormDragAdd(evt, subList) {
      const newIndex = evt.newIndex;
      const curWidget = subList[newIndex];
      if (subList[newIndex]) {
        this.designer.setSelected(subList[newIndex]);
      }
      // 移入的组件,自动加上宽
      curWidget.options.columnWidth ??= "200px";
      this.designer.emitHistoryChange();
      this.designer.emitEvent("field-selected", this.widget);
    },

    onSubFormDragEnd(evt) {}
  }
};
</script>

<style lang="scss" scoped>
$--color-primary: var(--theme-color);
.custom-sub-form-container {
  //width: 100%;
  padding: 8px;
  border: 1px dashed #336699;

  ::v-deep .sub-form-table {
    min-height: 68px;

    div.sub-form-table-column {
      display: inline-block;
      vertical-align: middle !important;
      //width: 200px;
    }
  }

  ::v-deep .ghost {
    content: "";
    font-size: 0;
    //height: 3px;
    height: 74px;
    width: 1px;
    box-sizing: border-box;
    display: inline-block;
    background: $--color-primary;
    border: 2px solid $--color-primary;
    outline-width: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }
}

.flex {
  display: flex;
}
.label {
  padding-right: 12px;
}
.custom-sub-form-container.selected {
  outline: 2px solid $--color-primary !important;
}

div.label-center-left {
  text-align: left;
}

div.label-center-align {
  text-align: center;
}

div.label-right-align {
  text-align: right;
}
</style>
